// extracted by mini-css-extract-plugin
export var actions = "_1f-0";
export var actionsContainer = "_1f-7";
export var border = "_1f-1";
export var childFullHeight = "_1f-e";
export var collapse = "_1f-2";
export var content = "_1f-9";
export var contentChild = "_1f-d";
export var fullscreen = "_1f-b";
export var hasLeftRadius = "_1f-q";
export var headerContainer = "_1f-3";
export var headerRow = "_1f-5";
export var hidePadding = "_1f-a";
export var navCollapsedGap = "_1f-r";
export var noScrollX = "_1f-s";
export var noScrollY = "_1f-t";
export var noTopPadding = "_1f-o";
export var optOutTopPadding = "_1f-c";
export var outletContent = "_1f-k";
export var outletContentInner = "_1f-l";
export var outletLeadingPanel = "_1f-h";
export var outletLeadingPanelAttention = "_1f-i";
export var outletResizeDivider = "_1f-j";
export var outletSplit = "_1f-f";
export var outletSplitResizing = "_1f-g";
export var pageMain = "_1f-p";
export var pageOuter = "_1f-m";
export var pagePadding = "_1f-8";
export var profile = "_1f-u";
export var profileContainer = "_1f-v";
export var profileImage = "_1f-w";
export var profileMain = "_1f-x";
export var profileSubtitle = "_1f-z";
export var profileTitle = "_1f-y";
export var showLeftPadding = "_1f-n";
export var tabsPortalSlot = "_1f-6";
export var tabsWrapper = "_1f-4";
export var title = "_1f-10";